angular.module('core').filter('name', [
    function() {
        return function(item) {
            if(!item) {
                return '';
            }
            if(_.isString(item)) {
                return item;
            }
            else if(item.name) {
                return item.name;
            }
            else if(item.first_name) {
              if (item.last_name) {
                return item.first_name + ' ' + item.last_name;
              } else {
                return item.first_name;
              }
            }  else if (item.last_name) {
                return item.last_name;
            } else {
                return '';
            }
        };
    }
]);
